// $(function() {
//    var count = 80;
//  $('.textOverflow').each(function() {
//      var thisText = $(this).text();
//       var textLength = thisText.length;
//        if (textLength > count) {
//           var showText = thisText.substring(0, count);
//           var insertText = showText += '…';
//           $(this).html(insertText);
//       };
//   });
// });

$(function () {
  var $text = $('.textOverflow');//対象のテキスト
  var $more = $('.more');//続きを読むボタン
  var lineNum = 5;//表示する行数
  var textHeight = $text.height();//テキスト全文の高さ
  var lineHeight = parseFloat($text.css('line-height'));//line-height
  var textNewHeight = lineHeight * lineNum;//指定した行数までのテキストの高さ

  // テキストが表示制限の行数を超えたら発動
  if (textHeight > textNewHeight) {
    $text.css({
      height: textNewHeight,
      overflow: 'hidden',
    });
		$('.showMoreDot').css("display","block");
    //続きを読むボタンクリックで全文表示
    // $more.click(function () {
    //   $(this).hide();
    //   $text.css({
    //     'height': textHeight,
    //     'overflow': 'visible',
    //   });
    //   return false;//aタグ無効化
    // });
  } else {
    // 指定した行数以下のテキストなら続きを読むは表示しない
    // $more.hide();
  }
});
